import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import { createPinia } from 'pinia'
import type { Directive } from "vue"

const LazyLoadDirective: Directive = {
  // Чтобы работало в компоненте указываем: v-lazy :data-src="variable"
  mounted(el) {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.boundingClientRect.top <= window.innerHeight + 500 || entry.boundingClientRect.bottom >= -500) {
          const lazyImage = entry.target as HTMLElement;
          if (lazyImage.dataset.src) {
            // Если элемент в поле видимости присваиваем data-src как backgroind-image
            lazyImage.style.backgroundImage = lazyImage.dataset.src;
            imageObserver.unobserve(el);
          }
        }
      });
    }, { threshold: 0.5 });
    imageObserver.observe(el);
  },
}

const app = createApp(App)
app.use(router)
app.use(createPinia())
app.directive("lazy", LazyLoadDirective)
app.mount("#app")
